import { Injectable } from '@angular/core';

import { UserManager } from './user-manager';

import { from } from 'rxjs';

@Injectable()
export class AuthGuardAllowAuthorized  {
    constructor(private _userManager: UserManager) {
    }

    canActivate() {
        return from (this._userManager.checkIfLoggedInOAuth());
    }
}
